export default "__VITE_ASSET__11c329d6__"